import { showJob } from "@/services/pages/clients/careers/showJob";
import { REDIRECT, TRANSLATION } from "@/imports-files/pages/clients/careers/showJob";

export class ShowJobAction
{
    async getData(values, data, update_props, isFrame)
    {
        values[`page`]        =    data.next_page;
        values['host_name']   =    window.location.hostname
        values['isFrame']     =    isFrame
        let result            =    await new showJob().getfilteredJobsData(values);
        result.data.jobs      =    data.jobs.concat(result.data.jobs)
        update_props(result.data);
    }


async handleValueOnChange(...args) 
{

    const name          =    args[0];
    const value         =    args[1];
    const hash          =    args[2];
    const update_value  =    args[3];
    const update_props  =    args[4];
    const data          =    args[5];
    const isFrame       =    args[6]
    let new_value       =    typeof value == 'object' ? value.value : value;
    hash[`${name}`]     =    value.value || value;
    hash['host_name']   =    window.location.hostname
    hash['isFrame']     =    isFrame
    hash['page'] = null
    if(new_value.length == 0) delete hash[`${name}`]
    update_value(hash);
    this.getSearchData(hash, data, update_props);
}

async getSearchData(values, data, update_props)
{
    // values[`page`]        =    data.next_page;
    let result            =    await new showJob().getfilteredJobsData(values);
    update_props(result.data);
}


get_json_data_for_jobOption(result, t)
{
    let data = [{label: t('placeholder:select:please'), value: ''}];
    if(result)
    {
        for( let element of result)
        {
            data.push({
                        value: element, 
                        label: element,
                    })
        }
    }
    return {options: data};
    
}

get_json_data_for_location(locations)
{
  let data = [{label: TRANSLATION('placeholder:select:please'), value: ''}];
  if(locations)
  {
    for( let element of locations)
    {
      data.push({
        value: element, 
        label: element,
      })
    }
  }
  return {options: data}; 
}

get_json_data_for_locationOption(job_location, job_countries)
{
   let countries_data = [{label: TRANSLATION('placeholder:select:please'), value: ''}];

    if( (job_location || false) && ( job_countries || false) && (job_location.length > 0 || job_countries.length > 0))
    {
        for( let element of job_location)
        {
            countries_data.push({
                                    value: element, 
                                    label: element
                                })
        }

        for( let element of job_countries)
        {
            countries_data.push({
                                    value: element, 
                                    label: element
                                })
        }
        return {options: countries_data};
    }
    else
    {
        return [];
    }
}

set_background_image(image_url)
{
   let element                   =  document.getElementsByClassName('Career_Background')[0];
   if(element)
   {  element.style.backgroundImage =  "url('"+image_url+"')"; }
}

redirectToJob(slug, client_slug, isFrame=false)
{
    let job_url        =  REDIRECT.client.jobs.view_job;
    let protocol       =  window.location.protocol;
    let hostnamearray  =  window.location.host.split('.');
    hostnamearray[0]   =  'jobs';
    job_url            =  job_url.replace('$slug', slug);
    job_url            =  job_url.replace('$client_slug', client_slug);
    let url            =  protocol + '//' + hostnamearray.join('.') + job_url+`?q=desc&isFrame=${isFrame}`;
    window.open(url, '_blank');
}

}

// export async function getData(values, data, update_props)
// {
//     values[`page`]        =    data.next_page;
//     values['host_name']   =    window.location.hostname
//     let result            =    await new showJob().getJobsData(values);
//     result.data.jobs      =    result.data.jobs.concat(data.jobs)
//     update_props(result.data);
// }


// export async function handleValueOnChange(...args) 
// {

//     const name          =    args[0];
//     const value         =    args[1];
//     const hash          =    args[2];
//     const update_value  =    args[3];
//     const update_props  =    args[4];
//     const data          =    args[5];
//     hash[`${name}`]     =    value.value || value;
//     hash['host_name']   =    window.location.hostname
//     update_value(hash);
//     getSearchData(hash, data, update_props);
// }

// export async function getSearchData(values, data, update_props)
// {
//     values[`page`]        =    data.next_page;
//     let result            =    await new showJob().getJobsData(values);
//     update_props(result.data);
// }


// export function get_json_data_for_jobOption(result)
// {
//     let data = [];
//     if(result)
//     {
//         for( let element of result)
//         {
//             data.push({
//                         value: element, 
//                         label: element,
//                     })
//         }
//     }
    
//     return {options: data};
    
// }

// export function get_json_data_for_location(locations)
// {
//   let data = [];
//   if(locations)
//   {
//     for( let element of locations)
//     {
//       data.push({
//         value: element, 
//         label: element,
//       })
//     }
//   }
//   return {options: data}; 
// }

// export function get_json_data_for_locationOption(job_location, job_countries)
// {
//    let countries_data = [];

//     if( (job_location || false) && ( job_countries || false) && (job_location.length > 0 || job_countries.length > 0))
//     {
//         for( let element of job_location)
//         {
//             countries_data.push({
//                                     value: element, 
//                                     label: element
//                                 })
//         }

//         for( let element of job_countries)
//         {
//             countries_data.push({
//                                     value: element, 
//                                     label: element
//                                 })
//         }

//         return {options: countries_data};
//     }
//     else
//     {
//         return [];
//     }
// }

// export function set_background_image(image_url)
// {
//    let element                   =  document.getElementsByClassName('Career_Background')[0];
//    if(element)
//    {  element.style.backgroundImage =  "url('"+image_url+"')"; }
// }

// export function redirectToJob(slug, client_slug)
// {
//     let job_url        =  REDIRECT.client.jobs.view_job;
//     let protocol       =  window.location.protocol;
//     let hostnamearray  =  window.location.host.split('.');
//     hostnamearray[0]   =  'jobs';
//     job_url            =  job_url.replace('$slug', slug);
//     job_url            =  job_url.replace('$client_slug', client_slug);
//     let url            =  protocol + '//' + hostnamearray.join('.') + job_url;
//     window.open(url, '_blank');
// }
